// extracted by mini-css-extract-plugin
export default {"balance":"UserBalance_balance__16zpR","icon":"UserBalance_icon__lNwWs","info":"UserBalance_info__P71In","label":"UserBalance_label__Kw-v7"};